<template>
  <div id="footer-bar" class="footer-bar">

    <router-link to="/framework" class="icon-link framework-link">
      <i class="fas fa-paw"></i><span>Framework</span>
     
    </router-link>
    
    <router-link to="/dashboard" class="icon-link framework-link">
      <i class="fas fa-tachometer-alt"></i><span>Dashboard</span>
    
    </router-link>


    <router-link to="/games/menu" class="icon-link framework-link">
      <i class="fas fa-dice"></i><span>Gaming</span>
      <span></span>
    </router-link>



    <router-link to="/gram" class="icon-link framework-link">
      <i class="fas fa-lightbulb"></i>
      <span>Learning Hub</span>
    </router-link>

    <router-link to="/chat" class="icon-link framework-link">
      <i class="fas fa-comments-dollar"></i>
      <span>MeowGPT</span>
    </router-link>
  </div>
</template>


<script>
</script>

<style scoped>
#footer-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  background: white;
  justify-content: space-evenly; /* Evenly distribute space between elements */
  align-items: center;
  color: #F0F0F0; /* A lighter shade for text */
  height: 80px; /* Adjusted height for a sleeker look */
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0 -4px 10px rgba(0,0,0,0.1);
  z-index: 1000;
}

.icon-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  font-size: 24px; /* Icon size */
  color: black /* Slightly dimmed text color */
}

.icon-link:hover {
  font-size: 24px; /* Icon size */
  color: #4A148C; /* Brighter white for hover */
  animation: bounce 0.5s ease;
}

.icon-link .logo {
  /* Styles for the images */
  width: 30px; /* Example size, adjust as needed */
  height: auto;
}


span {
  font-size: 14px;
  transition: color 0.3s ease; /* Smooth transition for text color */
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
.framework-link span {
  font-size: 10px; /* Super small text for "Framework" */
}
</style>
